<script>

    import { joinGame, requestToJoin } from "./net";
    import { ui, prefs } from "./stores";
    import { deleteItem } from "./anydb";


    export let games;
    export let requests;


    function requestedBy(id, captain){
        let f = requests.find(r => r.nanoid == id && r.requesting_captain == captain);
        if(!f) return false;
        return {
                username: f.requesting_username,
                status: f.status
            }
    }

    function myTurn(g){
        if(g.captain1_username == $prefs.username && g.activePlayer == g.captain1) return true;
        if(g.captain2_username == $prefs.username && g.activePlayer == g.captain2) return true;
        return false;
    }

    function byMostRecent(a,b){
        let aScore = 0;
        let bScore = 0;
        if(myTurn(a)) aScore = 100;
        if(myTurn(b)) bScore = 100;
        if(aScore != bScore) return bScore-aScore;
        
        return new Date(b.whenSaved || b.created_at) - new Date(a.whenSaved || a.created_at);
    }

    $: sortedGames = [...games].sort(byMostRecent);

</script>

<tr>
    <th>Host</th>
    <th>Captain 1 </th>
    <th>Captain 2</th>
    <th>Turn</th>
    <th>Started</th>
    <th>Last updated</th>
    <th>Actions</th>
</tr>
    
    {#each sortedGames as g}
        <tr>
            <td>{g.host}</td>
            <td class:active={g.activePlayer == g.captain1}>{g.captain1}
                <span class:you={g.captain1_username == $prefs.username}>
                    {g.captain1_username} 
                    {#if requestedBy(g.nanoid, g.captain1, requests)}
                        {@const r = requestedBy(g.nanoid, g.captain1, requests)}
                        {#if r.status == 'requested'} requested by {r.username}
                        {/if}
                    {:else if g.captain1_username != $prefs.username && g.captain2_username != $prefs.username && g.captain1_username == g.host}<button on:click={e => {requestToJoin(g.nanoid, g.captain1)}}>Ask to play</button>
                    {/if}
                </span>
            </td>
            <td class:active={g.activePlayer == g.captain2}>{g.captain2}
                <span class:you={g.captain2_username == $prefs.username}>{g.captain2_username} 
                    {#if requestedBy(g.nanoid, g.captain2, requests)}
                        {@const r = requestedBy(g.nanoid, g.captain2, requests)}
                        {#if r.status == 'requested'} requested by {r.username}
                        {/if}
                    {:else if g.captain2_username != $prefs.username && g.captain1_username != $prefs.username && g.captain2_username == g.host}
                        <button on:click={e => {requestToJoin(g.nanoid, g.captain2)}}>Ask to play</button>
                    {/if}
                </span>
            </td>
            <td>{g.turn}</td>
            <td>{g.times ? g.times.created_at : ''}</td>
            <td>{g.times ? g.times.whenSaved : ''}</td>
            
            <td>
                {#if g.captain1_username == $prefs.username}<button on:click={e => {joinGame(g, g.captain1)}}>Enter</button>
                {:else if g.captain2_username == $prefs.username}<button on:click={e => {joinGame(g, g.captain2)}}>Enter</button>
                {:else}<button on:click={e => {joinGame(g, false)}}>Observe</button>
                {/if}
                {#if $prefs.username == g.host}
                    <button class="delete" on:click={e => {
                        if(confirm('Really delete game?')) deleteItem('current_games', 'nanoid', g.nanoid)
                    }}>
                        Delete
                    </button>
                {/if}
            </td>
        </tr>
    {/each}

    
        <dialog open={$ui.requestGranted}>
            {#if $ui.requestGranted}
                <div>Your request to join game as {$ui.requestGranted.captain} has been granted. Join now?</div>
                <div>
                    <button class="dialog ok" on:click={e => {joinGame($ui.requestGranted.id, $ui.requestGranted.captain)}}>Yes</button>
                    <button class="dialog cancel" on:click={e => {$ui.requestGranted = false;}}>No</button>
                    
                </div>
            {/if}
        </dialog>

<style>

    ::backdrop, /* for native <dialog> */
dialog + .backdrop {
  /* for dialog-polyfill */
  /* a transparent shade of gray */
  background-color: rgba(0, 0, 0, 0.2);
}

dialog[open] {
        position: fixed;
        z-index: 300;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        padding: 2vmin;
        /* padding-bottom: 1vmin; */
        height: fit-content;
        width: fit-content;
        max-height: 20vh;
        max-width: 90vw;
        min-width: 60vw;
        overflow: auto;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        color: white;
        background-color: rgba(2,2,2,0.5);
        border: unset;
        border-radius: 30px;
        box-shadow: 0 0 10px 5px white;
        color: white;
        display: block;
        overflow-y: auto; 
        height: 100%; 
        width: 100%; 
        flex-wrap: nowrap; 
        margin-left: 2vmin; 
        margin-right: 2vmin; 
        justify-content: space-between;
        gap: 10px;
    }

    

    button.dialog {
		border-radius: 1vmin; 
        color: white;
		background: rgba(150,150,150,0.5);
		filter: drop-shadow(0.5vmin 0.5vmin 0.5vmin slategray);
	}

    .ok {
        background: rgba(0,255,0,0.5);
    }

    .cancel {
        background: rgba(255,0,0,0.5);
    }
    

.active {
        color: lightgreen;
        font-weight: bold;
    }

    .you {
        font-style: italic;
    }

    .delete {
        background-color: red;
        color: white;
    }

    td, th {
        text-align: left;
        padding: 0.5vmin;
    }
    table, tr, td, th {
        border: 1px solid white;
        border-collapse: collapse;
    }

</style>
